import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';
import { filter, map, take, tap } from 'rxjs';
import { CoreStore } from '../core/store/core.store';

export const canMatchRestrictedArea: CanMatchFn = () => {
  const store = inject(CoreStore);
  const router = inject(Router);

  if (store.sessionExists()) {
    return true;
  }

  store.checkSessionExists();
  const sessionExists$ = toObservable(store.sessionExists);
  return sessionExists$.pipe(
    filter((sessionExists: boolean | null) => sessionExists !== null),
    tap(() => store.getMe()),
    take(1),
    map((exists: boolean) => exists || router.createUrlTree(['/', 'auth']))
  );
};
